import { createFileRoute } from "@tanstack/react-router";
import { BnServiceDetail, bnServiceHead, type BnServiceContent } from "@/components/bn/BnServiceDetail";

const C: BnServiceContent = {
  path: "/bn/services/geo",
  enPath: "/services/geo",
  crumb: "GEO",
  title: "GEO সার্ভিস — Google AI Overviews ও AI Mode-এ জায়গা নিন",
  desc: "জেনারেটিভ ইঞ্জিন অপটিমাইজেশন (GEO) সার্ভিস। প্যাসেজ অপটিমাইজেশন, স্কিমা ও তথ্যসমৃদ্ধ কনটেন্টের মাধ্যমে Google AI Overviews, AI Mode ও জেনারেটিভ সার্চে আপনার সাইটকে দৃশ্যমান করি।",
  keywords: ["geo service bangladesh", "GEO সার্ভিস", "জেনারেটিভ ইঞ্জিন অপটিমাইজেশন", "Google AI Overviews"],
  eyebrow: "জেনারেটিভ ইঞ্জিন অপটিমাইজেশন",
  h1: <>জায়গা নিন <span className="text-gradient">Google AI Overviews</span> ও AI Mode-এ।</>,
  subtitle: "GEO আপনার সবচেয়ে গুরুত্বপূর্ণ পেজগুলোকে এমন অনুচ্ছেদে পরিণত করে, যেগুলো গুগলের জেনারেটিভ উত্তর উদ্ধৃত করে — এআই সার্চের যুগে ট্রাফিক রক্ষা করে।",
  takeaways: [
    "GEO-র লক্ষ্য গুগলের নিজস্ব এআই উত্তর — AI Overviews ও AI Mode।",
    "গুগল যেসব পেজে আগে থেকেই ভরসা করে, সেগুলো থেকেই উত্তর তৈরি হয়; তাই শক্ত এসইও ভিত্তি জরুরি।",
    "প্যাসেজ-স্তরের লেখা, স্কিমা ও নিজস্ব ডেটা — এই তিনটি জেনারেটিভ উত্তরে জায়গা পাওয়ার মূল চাবি।",
  ],
  programTitle: "GEO প্রোগ্রাম",
  programDesc: "মাসিক রিটেইনার, যেখানে কোন প্রশ্নে আপনি জিততে পারেন তা চিহ্নিত করে সেই পেজগুলো নিয়মিত শক্তিশালী করা হয়।",
  price: "GEO রিটেইনার: মাসে ৩০,০০০–৭০,০০০ টাকা",
  cta: "GEO নিয়ে কথা বলুন",
  deliverables: [
    "AI Overview যোগ্যতা অডিট (কোন প্রশ্নে জেতা সম্ভব)",
    "জেনারেটিভ উত্তরের জন্য প্যাসেজ-স্তরের অপটিমাইজেশন",
    "এন্টিটি, FAQ, HowTo ও Article স্কিমা",
    "উদ্ধৃতি টানার মতো কনটেন্ট (ডেটা, পরিসংখ্যান, নিজস্ব গবেষণা)",
    "Google AI Mode ও AI Overview ট্র্যাকিং ড্যাশবোর্ড",
    "ত্রৈমাসিক জেনারেটিভ শেয়ার-অফ-ভয়েস রিপোর্ট",
  ],
  outcomes: ["AI Overviews-এ উপস্থিতি", "এআই যুগেও ট্রাফিক রক্ষা", "গুরুত্বপূর্ণ প্রশ্নে উৎস হিসেবে পরিচিতি"],
  faqs: [
    { q: "জেনারেটিভ ইঞ্জিন অপটিমাইজেশন (GEO) কী?", a: "GEO হলো কনটেন্ট, স্ট্রাকচার ও এন্টিটি সিগন্যাল এমনভাবে অপটিমাইজ করা, যাতে Google AI Overviews, AI Mode ও অন্যান্য জেনারেটিভ সার্চে আপনার ব্র্যান্ড দেখা যায়।" },
    { q: "GEO আর AEO কি একই?", a: "মিল আছে, তবে এক নয়। AEO-র লক্ষ্য আলাদা এআই অ্যাসিস্ট্যান্ট (ChatGPT, Perplexity, Claude)। GEO-র লক্ষ্য সার্চ ইঞ্জিনের ভেতরের জেনারেটিভ উত্তর — মূলত Google AI Overviews ও AI Mode।" },
    { q: "GEO কি এসইও-র বিকল্প?", a: "না। GEO শক্ত এসইও-র ওপর দাঁড়িয়ে থাকে। গুগল যে পেজগুলোকে আগেই বিশ্বাস করে সেখান থেকেই AI Overviews তৈরি হয়, তাই র‍্যাংকিং, এন্টিটি অথরিটি ও স্কিমা সবই GEO-কে প্রভাবিত করে।" },
    { q: "GEO-র ফলাফল কীভাবে মাপা হয়?", a: "Search Console-এর ডেটা, Google AI Mode-এ লক্ষ্য প্রশ্নগুলোর নিয়মিত পরীক্ষা, শেয়ার-অফ-ভয়েস টুল এবং ব্র্যান্ড উল্লেখ মনিটরিংয়ের মাধ্যমে।" },
  ],
  serviceName: "জেনারেটিভ ইঞ্জিন অপটিমাইজেশন (GEO)",
  serviceType: "Generative Engine Optimization",
  related: [
    { to: "/bn/services/aeo", label: "AEO প্রোগ্রাম দেখুন" },
    { to: "/bn/services/seo", label: "এসইও সার্ভিস" },
  ],
};

export const Route = createFileRoute("/bn/services/geo")({
  head: () => bnServiceHead(C),
  component: () => <BnServiceDetail c={C} />,
});
